module.exports = __webpack_public_path__ + "static/media/file.8d1bc320.svg";